import axios from "../utils/request";

export default {
  /**
   * 视频列表
   * @param {*} data
   * @returns
   */
  videoList(data) {
    return axios.get("video/list", { ...data });
  },
  /**
   *视频详情
   * @param {*} id
   * @returns
   */
  videoDetail(id) {
    return axios.get("video/detail", { id });
  },
  /**
   * 上传视频
   * @param {*} data
   * @returns
   */
  videoUpload(data) {
    return axios.post("video/upload", data);
  },

  /**
   * 个人中心--视频列表
   */
  myVideoList(data) {
    return axios.get("video/myList", { ...data });
  },
  /**
   * 个人中心--视频详情
   * @param {*} id
   * @returns
   */
  myVideoDetail(id) {
    return axios.get("video/myVideoDetail", { id });
  },
  /**
   *修改视频
   * @param {*} data
   * @returns
   */
  myVideoEdit(data) {
    return axios.post("video/edit", data);
  },
  /**
   * 删除视频
   * @param {*} id
   * @returns
   */
  myVideoDelete(id) {
    return axios.get("video/delete", { id });
  },
  /**
   * 视频详情
   * @param {*} id
   * @returns
   */
  myVideoDetail(id) {
    return axios.get("video/videoDetail", { id });
  },
  /**
   * 推荐视频列表
   * @param {*} data
   * @returns
   */
  recommendList(data) {
    return axios.get("/video/recommendList", { ...data });
  },
};
